import React, { Component } from "react";
import { connect } from "react-redux";
import { Grid, Row, Col, OverlayTrigger, Popover } from "react-bootstrap";
import { Card } from "components/Card/Card.jsx";
import { withRouter } from "react-router-dom";
import { shippingOptionsActions } from "../../../redux/actions/shipping-options-actions";
import SimpleReactValidator from "simple-react-validator";
import { confirmAlert } from "react-confirm-alert";
import Confirmalertfordelete from "../../ThemeComponents/confirmAlertForDelete";
import { hasPermission } from "helper/hasPermission";
import { adminLabels } from "../../../redux/constant/admin-label-constant";

// dropdown components //
import CustomerDropdown from "../Customers/CustomerDropdown";

class ShippingOptions extends Component {
    constructor(props) {
        super(props);
        this.validator = new SimpleReactValidator();

        const user = localStorage.getItem('user') !== null ? JSON.parse(localStorage.getItem('user')).result.user : undefined;
        let model_id;
        let model;
        if (user.model === 'App\\Customer') {
            model_id = user.model_id;
            model = this.props.match.params.model;
        }
        else {
            model_id = this.props.match.params.id;
            model = this.props.match.params.model;
        }

        this.state = {
            loggedInUserType: user.model,
            formData: {
                title: "",
                account: "",
                customer_id: model_id,
                model: model
            },
            showDropdown: model_id !== "all" ? false : true
        };
    }

    componentDidMount() {
        const { customer_id } = this.state.formData;
        this.props.getShippingOptions(customer_id);
    }

    inputChangeHandler = e => {
        this.setState({
            formData: {
                ...this.state.formData,
                [e.target.name]: e.target.value
            }
        });
    };

    handleFormSubmit = e => {
        e.preventDefault();
        if (this.validator.allValid()) {
            const { formData } = this.state;
            this.props.storeShippingOptionCall(formData);

            this.setState({
                formData: {
                    ...this.state.formData,
                    account: "",
                    title: ""
                }
            });
            this.validator.hideMessages();
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    };

    renderList() {
        return this.props.shippingOptionsList.map((row, index) => {
            return (
                <tr key={index}>
                    <td>{row.title}</td>
                    <td>{row.account}</td>
                    <td className="text-center">
                        <OverlayTrigger
                            placement="bottom"
                            overlay={
                                <Popover id="tooltip">
                                    {hasPermission(
                                        "customer-can-manage-shipping-options"
                                    )
                                        ? `Delete Row`
                                        : adminLabels.DONT_ALLOW}
                                </Popover>
                            }
                        >
                            <span>
                                <button
                                    onClick={
                                        hasPermission(
                                            "customer-can-manage-shipping-options"
                                        )
                                            ? () => this.deleteConfirmItem(row)
                                            : null
                                    }
                                    className="deleteIcon orderDetailsAction"
                                >
                                    &nbsp;
                                </button>
                            </span>
                        </OverlayTrigger>
                    </td>
                </tr>
            );
        });
    }

    deleteConfirmItem(row) {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <Confirmalertfordelete
                        typeName={row.title}
                        description={"Are you sure to delete the" + row.title}
                        onClosePro={onClose}
                        deleteType={() =>
                            this.props.deleteShippingOptionCall(row.id)
                        }
                    />
                );
            }
        });
    }

    componentDidUpdate(prevProps) {
        if (this.props.match.params.model !== prevProps.match.params.model) {
            const { customer_id } = this.state.formData;
            this.props.getShippingOptions(customer_id);
        }
    }

    getFullState = state => {
        this.setState(
            prevState => ({
                formData: {
                    ...prevState.formData,
                    customer_id: state.model_id
                }
            }),
            () => {
                const { customer_id } = this.state.formData;
                this.props.getShippingOptions(customer_id);
            }
        );
    };

    render() {
        const tableRows = this.renderList();

        return (
            <React.Fragment>
                <div className="content">
                    <Grid fluid>
                        <Row>
                            <Col md={12}>
                                <Card
                                    ctTableResponsive
                                    content={
                                        <div>
                                            {this.state.showDropdown && (
                                                <div
                                                    className="col-md-5"
                                                    style={{
                                                        paddingRight: "10px",
                                                        float: "right"
                                                    }}
                                                >
                                                    <CustomerDropdown
                                                        onReturnFullState={
                                                            this.getFullState
                                                        }
                                                        stateProp={this.state}
                                                    />
                                                </div>
                                            )}

                                            <Grid fluid>
                                                <Row>
                                                    <Col
                                                        md={12}
                                                        style={{
                                                            textAlign: "center"
                                                        }}
                                                    >
                                                        <h3 className="mt-lg">
                                                            Manage Shipping Options
                                                        </h3>
                                                    </Col>

                                                    <Col md={12}>
                                                        <form
                                                            onSubmit={
                                                                this
                                                                    .handleFormSubmit
                                                            }
                                                        >
                                                            <div className="well pt-sm pb-sm pl-md pr-md mb-xlg mt-xlg">
                                                                <div className="row">
                                                                    <div className="col-md-4">
                                                                        <div className="permissionList ">
                                                                            <input
                                                                                type="text"
                                                                                name="title"
                                                                                className="form-control"
                                                                                placeholder="Input Shipping Option"
                                                                                onChange={
                                                                                    this
                                                                                        .inputChangeHandler
                                                                                }
                                                                                value={
                                                                                    this
                                                                                        .state
                                                                                        .formData
                                                                                        .title
                                                                                }
                                                                            />
                                                                            {this.validator.message(
                                                                                "title",
                                                                                this
                                                                                    .state
                                                                                    .formData
                                                                                    .title,
                                                                                "required"
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-4">
                                                                        <div className="permissionList ">
                                                                            <input
                                                                                type="text"
                                                                                name="account"
                                                                                className="form-control"
                                                                                placeholder="Input Account Id/Ref No. (Optional)"
                                                                                onChange={
                                                                                    this
                                                                                        .inputChangeHandler
                                                                                }
                                                                                value={
                                                                                    this
                                                                                        .state
                                                                                        .formData
                                                                                        .account
                                                                                }
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-4">
                                                                        <div className=" text-center">
                                                                            {this
                                                                                .state
                                                                                .formData
                                                                                .customer_id !==
                                                                                undefined &&
                                                                                (hasPermission(
                                                                                    "customer-can-manage-shipping-options"
                                                                                ) ? (
                                                                                        <input
                                                                                            style={{ maxWidth: '100%' }}
                                                                                            type="submit"
                                                                                            value="Add Shipping Option"
                                                                                            className="customBtn block btnBlue"
                                                                                        />
                                                                                    ) : (
                                                                                        <input
                                                                                            style={{ maxWidth: '100%' }}
                                                                                            type="button"
                                                                                            value="Add Shipping Option"
                                                                                            className="customBtn block btnBlue button_disabled"
                                                                                            disabled="disabled"
                                                                                        />
                                                                                    ))}

                                                                            {(this
                                                                                .state
                                                                                .formData
                                                                                .customer_id ===
                                                                                undefined ||
                                                                                this
                                                                                    .state
                                                                                    .formData
                                                                                    .customer_id ===
                                                                                "all") && (
                                                                                    <React.Fragment>
                                                                                        <input
                                                                                            style={{ maxWidth: '100%' }}
                                                                                            type="button"
                                                                                            value="Add Shipping Option"
                                                                                            className="customBtn block btnBlue button_disabled"
                                                                                            disabled="disabled"
                                                                                        />
                                                                                        <div className="mt-xs">
                                                                                            <small>
                                                                                                Please select customer to Add new shipping option
                                                                                            </small>
                                                                                        </div>
                                                                                    </React.Fragment>
                                                                                )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {/* <div className="row">
                                                                <div className="col-md-12 mb-xlg">
                                                                  
                                                                </div>
                                                            </div> */}
                                                        </form>

                                                        <table className="table theme_table">
                                                            <thead>
                                                                <tr>
                                                                    <td>
                                                                        Shipping
                                                                        Option
                                                                    </td>
                                                                    <td>
                                                                        Account
                                                                        ID
                                                                    </td>
                                                                    <td>
                                                                        Control
                                                                    </td>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {tableRows}
                                                            </tbody>
                                                        </table>
                                                    </Col>
                                                </Row>
                                            </Grid>
                                        </div>
                                    }
                                />
                            </Col>
                        </Row>
                    </Grid>
                </div>
            </React.Fragment>
        );
    }
}
const mapDispatchToProps = dispatch => {
    return {
        getShippingOptions: custId => {
            dispatch(shippingOptionsActions.getCustomerShippingOptions(custId));
        },
        storeShippingOptionCall: data => {
            dispatch(shippingOptionsActions.storeShippingOption(data));
        },
        deleteShippingOptionCall: data => {
            dispatch(shippingOptionsActions.deleteShippingOption(data));
        }
    };
};

const mapStateToProps = state => {
    const { shippingOptions } = state.shippingOptionReducer;
    return {
        shippingOptionsList: shippingOptions
    };
};

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(ShippingOptions)
);



// WEBPACK FOOTER //
// ./src/components/Admin/Customers/ShippingOptions.jsx